import { render, staticRenderFns } from "./IdeaManagement.vue?vue&type=template&id=6146eec4&v-if=isLoggedIn&"
import script from "./IdeaManagement.vue?vue&type=script&lang=js&"
export * from "./IdeaManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports